export const FALLBACK_ACTIVE_SEASON = '2026/27';
export const ARCHIVE_SEASONS = ['2025/26'];

export const getActiveSeason = (settings) =>
  settings?.activeSeason || process.env.REACT_APP_ACTIVE_SEASON || FALLBACK_ACTIVE_SEASON;
